import axios from "axios";
import { API_URL } from "../config/Config";

export default function ObjectionsService() {
    this.getAllAnomalies = (id) => {
        var url = `${API_URL}/UserManagement/getAnomalies?id=${id}`;
        return axios.get(url).then((response) => response.data);
    };
    this.getAllObjectionType = () => {
        var url = `${API_URL}/DataInspection/GetObjectionTypes1`;
        return axios.get(url).then((response) => response.data);
    };
    this.getAllObjectionStatuses = () => {
        var url = `${API_URL}/DataInspection/GetObjectionStatuses`;
        return axios.get(url).then((response) => response.data);
    };
    this.getObjectionsByID = (ID) => {
        var url = `${API_URL}/DataInspection/GetObjectionsByRegistrationNo?regNo=${ID}`;
        return axios.get(url).then((response) => response.data.Objections);
    };
    this.getObjectionsByTypeStatusAndEvent = (id1, id2, id3) => {
        var url = `${API_URL}/DataInspection/GetObjections?ObjectionTypeID=${id1}&ObjectionStatusID=${id2}&EventID=${id3}`;
        return axios.get(url).then((response) => response.data.Objections);
    };
    this.createObjection = (data) => {
        var url = `${API_URL}/DataInspection/InsertObjection`;
        return axios.post(url, data).then((response) => response.data);
    };
    this.adjudicateObjection = (id1, id2, reason) => {
        var url = `${API_URL}/DataInspection/AdjudicateObjection?ObjectionID=${id1}&ObjectionStatusID=${id2}&StatusReason=${reason}`;
        return axios.post(url).then((response) => response.data);
    };
}
